module.exports = __webpack_public_path__ + "static/img/album-status-5.c3c0e149.png";